document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ca-format-family]').forEach((root) => {
    const copy = JSON.parse(root.querySelector('[data-ca-family-copy]').textContent);
    const formatInputs = [...root.querySelectorAll('[data-ca-family-format]')];
    const productInputs = [...root.querySelectorAll('[data-ca-family-product]')];
    const groups = [...root.querySelectorAll('[data-ca-family-offers]')];
    const form = root.querySelector('[data-ca-family-form]');
    const summary = root.querySelector('[data-ca-family-summary]');
    const price = root.querySelector('[data-ca-family-price]');
    const delivery = root.querySelector('[data-ca-family-delivery]');
    const add = root.querySelector('[data-ca-family-add]');
    const money = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: root.dataset.currency });

    const selectedItems = () => formatInputs.filter((input) => input.checked).map((input) => {
      const choice = root.querySelector(`[data-ca-family-product][data-format="${input.value}"]:checked`);
      return choice ? {
        id: Number(choice.value),
        format: input.value,
        title: choice.dataset.title,
        priceCents: Number(choice.dataset.priceCents),
        priceDisplay: choice.dataset.priceDisplay,
        available: choice.dataset.available === 'true',
      } : null;
    }).filter(Boolean);

    const render = () => {
      const selectedFormats = new Set(formatInputs.filter((input) => input.checked).map((input) => input.value));
      formatInputs.forEach((input) => input.closest('label').classList.toggle('is-selected', input.checked));
      groups.forEach((group) => { group.hidden = !selectedFormats.has(group.dataset.caFamilyOffers); });
      productInputs.forEach((input) => input.closest('label').classList.toggle('is-selected', input.checked));
      const items = selectedItems();
      if (!items.length) {
        summary.textContent = copy.select_format;
        price.textContent = copy.choose;
        delivery.textContent = '';
        add.textContent = copy.choose;
        add.disabled = true;
        return;
      }
      const unavailable = items.some((item) => !item.available);
      summary.textContent = items.map((item) => item.title).join(' + ');
      price.textContent = items.length === 1 ? items[0].priceDisplay.replace(/<[^>]*>/g, '') : money.format(items.reduce((sum, item) => sum + item.priceCents, 0) / 100);
      delivery.textContent = items.map((item) => item.format === 'print' ? copy.physical_book : item.format === 'ebook' ? copy.ebook : copy.audio).join(' + ');
      const formatLabel = items[0].format === 'audio' ? 'audiobook' : items[0].format;
      add.textContent = unavailable ? copy.selected_sold : copy.add;
      add.disabled = unavailable;
    };

    formatInputs.forEach((input) => input.addEventListener('change', render));
    productInputs.forEach((input) => input.addEventListener('change', () => {
      if (input.dataset.editionUrl) {
        window.location.assign(input.dataset.editionUrl);
        return;
      }
      const format = root.querySelector(`[data-ca-family-format][value="${input.dataset.format}"]`);
      if (format) format.checked = true;
      render();
    }));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const items = selectedItems();
      if (!items.length || items.some((item) => !item.available)) return;
      const oldText = add.textContent;
      add.disabled = true;
      add.textContent = copy.adding;
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map((item) => ({ id: item.id, quantity: 1 })) }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        add.disabled = false;
        add.textContent = oldText;
        summary.textContent = copy.cart_error;
      }
    });

    render();
  });
});
